namespace GeniuzPOS.ReportMasterData {
    export interface Report_1312Form {
        DocDate: Serenity.DateEditor;
        ShopId: Serenity.LookupEditor;
        ShopName: Serenity.StringEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat1Name: Serenity.StringEditor;
        Qty: Serenity.DecimalEditor;
        GrossSales: Serenity.DecimalEditor;
        AllItemDiscount: Serenity.DecimalEditor;
        NetSalesExVat: Serenity.DecimalEditor;
        VatOfNetSales: Serenity.DecimalEditor;
    }

    export class Report_1312Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1312';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1312Form.init)  {
                Report_1312Form.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(Report_1312Form, [
                    'DocDate', w0,
                    'ShopId', w1,
                    'ShopName', w2,
                    'SubCat1Code', w1,
                    'SubCat1Name', w2,
                    'Qty', w3,
                    'GrossSales', w3,
                    'AllItemDiscount', w3,
                    'NetSalesExVat', w3,
                    'VatOfNetSales', w3
                ]);
            }
        }
    }
}
